import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userManagementActions } from '../../_actions';
import moment from 'moment';
import Pagination from '../../components/Pagination/Pagination';
import Loader from '../../components/Atoms/Loader';
import Nodata from '../../components/Atoms/NoData/NoData';

const MerchantApprovedAPI = () => {
  const dispatch = useDispatch();
  const selector = useSelector(state => state);
  const [activeTab, setActiveTab] = useState('enabled');
  const { userManagement: { getMerchantApiKeyList = [], merchantApiKeyTotal,disableTotal,activeTotal, loading } } = selector ? selector : {};

  const size = 10;
  const [pageNo, setPageNo] = useState(1);

  const filteredMerchants = useMemo(() => {
    return getMerchantApiKeyList.filter(merchant =>
      activeTab === 'enabled' ? merchant.isActive : !merchant.isActive
    );
  }, [getMerchantApiKeyList, activeTab]);




  const apiPayload = useMemo(() => ({
    keyWord: "",
    fromDate: "",
    toDate: "",
    sortBy: 'createdAt',
    sortOrder: 'desc',
    pageNo,
    size: size,
    isDisable: activeTab === 'enabled' ? false : true,
  }), [pageNo, activeTab]);

  useEffect(() => {
    dispatch(userManagementActions.getMerchantApiKeyListAdmin(apiPayload));
  }, [dispatch, apiPayload]);

  const onPageChange = useCallback((page) => {
    setPageNo(page);
  }, []);

  const handleToggleStatus = useCallback((merchantId, currentStatus) => {

    dispatch(userManagementActions.toggleMerchantApiKeyStatus({
      merchantId,
      status: !currentStatus
    })).then(() => {
      dispatch(userManagementActions.getMerchantApiKeyListAdmin(apiPayload));
    });
  }, [dispatch, apiPayload]);

  return (
    <div className="p-6 overflow-hidden overflow-y-auto">
      <Loader loading={loading} />
      <h1 className="mb-6 text-2xl font-bold text-gray-800">Merchant Approved (API's)</h1>

      <div className="flex mb-6 border-gray-200">
        <button
          className={`py-2 px-4 relative ${activeTab === 'enabled' ? 'text-[#0F172A] font-[600] text-[14px]' : 'text-[#0F172AB2] text-[14px] font-[600] '}`}
          onClick={() => {
            setActiveTab('enabled');
            setPageNo(1);
          }}
        >
          Enabled ({activeTotal})
          {activeTab === 'enabled' && <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#00811D]"></div>}
        </button>
        <button
          className={`py-2 px-4 relative ${activeTab === 'disabled' ? 'text-[#0F172A] font-[600] text-[14px]' : 'text-[#0F172AB2] text-[14px] font-[600] '}`}
          onClick={() => {
            setActiveTab('disabled');
            setPageNo(1);
          }}
        >
          Disabled ({disableTotal})
          {activeTab === 'disabled' && <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#00811D]"></div>}
        </button>
      </div>

      <div className="space-y-6">
        {filteredMerchants.length > 0 ? (
          filteredMerchants.map(merchant => (
            <div key={merchant.id} className="overflow-hidden border border-gray-200 rounded-lg">
              <div className="flex items-center justify-between px-6 py-3 border-b bg-gray-50">
                <div className={`font-[600] text-[16px] ${merchant.isActive ? 'text-[#00811D]' : 'text-[#F6465D]'}`}>
                  {merchant.isActive ? 'Enabled' : 'Disabled'} by {merchant.enabledBy || merchant.disabledBy || 'Admin'}
                </div>
                <div className={`px-3 py-2 text-sm font-[600] text-[12px] rounded-md ${merchant.isActive ? 'text-[#00811D] bg-[#00811D1A]' : 'text-[#F6465D] bg-[#F6465D1A]'}`}>
                  {moment(merchant.updatedAt).format('DD-MMM-YYYY')}
                </div>
              </div>
              <div className="p-6">
                <div className="grid grid-cols-2 gap-y-4">
                  <div className="text-[#1D1F2C] text-[14px] font-[500]">Store Name</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">{merchant?.storeId?.storeName}</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500]">Store URL</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">{merchant?.storeId?.storeURL}</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500]">Company name</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">{merchant?.storeId?.companyName}</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500]">API Status</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">
                    <button
                      onClick={() => handleToggleStatus(merchant.id, merchant.isActive)}
                      className={`px-3 py-1 rounded-md ${merchant.isActive ? 'bg-[#F6465D1A] text-[#F6465D]' : 'bg-[#00811D1A] text-[#00811D]'}`}
                    >
                      {merchant.isActive ? "Enable" : "Disable"}
                    </button>
                  </div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500]">Active Sub Stores</div>
                  <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">{merchant.activeSubStores}</div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-gray-500 border">
            <Nodata />
          </div>
        )}
      </div>

      {Math.ceil(merchantApiKeyTotal / size) > 1 && (
        <Pagination
          totalPages={Math.ceil(merchantApiKeyTotal / size)}
          currentPage={pageNo}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default MerchantApprovedAPI;